export default __webpack_public_path__ + "static/media/img-merchant-wallet-new.bbc42bb4.jpg";